import { render } from "./not_found.vue?vue&type=template&id=dafc2b40"
import script from "./not_found.vue?vue&type=script&lang=js"
export * from "./not_found.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__